import React, { Component } from "react";
import { Row, Col } from "antd";
import { GrantTable } from "../../style";
import RenderCard from "../RenderCard/RenderCard";
import { GrantMob } from "../ContentComponent/style";
import { NoData } from "../../../../../../CommonComponents/commonStyles";
import { checkIEBrowser } from "../../../../../../utils/commonUtil";
import  PropTypes from 'prop-types';

class TableRender extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: ""
    };
    this.userData = JSON.parse(sessionStorage.getItem("primaryAccount"));
  }

  render() {
    const { search, data, column, text, className, handleChange} = this.props;
    const agreementCTA = true;
    const IE = checkIEBrowser();  
    return (
      <>
        <Row>
          <Col lg={24} md={0} xs={0} sm={0} className ="GrantTableHeightWithScroll alignSortIcon"> 
            <>
              {data && (
                <GrantTable
                  data-test = "grantTable"
                  className={`main grantActivitySortIcon ${className}`}
                  ie={IE}
                  dataSource={data}
                  columns={column}
                  pagination={false}
                  onChange={handleChange}
                  scroll={{ y: 500 }}
                  locale={{
                    emptyText: () => {
                      return (
                        <div style={{ padding: 20 }}>
                          {search
                            ? `No results found for ‘${search}'`
                            : `${text}`}
                        </div>
                      );
                    }
                  }}
                />
              )}
            </>
          </Col>
          <Col lg={0} sm={24} xs={24} md={24}>
            <>
              <GrantMob id="mobile-lazy">
                {!data.length && <NoData>No grants found.</NoData>}
                {data &&
                  data.length &&
                  data.map((data, index) => (
                    <RenderCard
                      key={"lazy" + index}
                      index={index}
                      data={data}
                      user={this.userData}
                      search={search}
                      component={this.props.card}
                      agreementCTA={agreementCTA}
                    />
                  ))}
              </GrantMob>
            </>
          </Col>
        </Row>
      </>
    );
  }
}

TableRender.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array,
  search: PropTypes.string,
  tab: PropTypes.string
}

export default TableRender;
